module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/store_images/4@2x_919e389fc26ddf4d25b613ac9adc0f4a.png";